import { type Product } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import ReactMarkdown from 'react-markdown';

import { OverviewImageGallery, OverviewMainImage } from './components/OverviewProductImages';
import { OverviewTabsWithChipsContent } from './components/OverviewTabsCard/OverviewTabsWithChipsContent';
import { OverviewTabsWithAccordion } from './components/OverviewTabsCard/TabsWithAccordion/OverviewTabsWithAccordion';
import { OverviewTabsWithMiscellaneousChips } from './components/OverviewTabsCard/TabsWithMiscellaneous/OverviewTabsWithMiscellaneousChips';

interface OverviewProps {
  product: Product;
  isLoggedIn: boolean;
  bleed?: number;
}

const OVERVIEW_PADDING = 2;

const Overview = ({ product, isLoggedIn, bleed = 0 }: OverviewProps) => {
  return (
    <Box sx={{ width: '100%', p: OVERVIEW_PADDING }}>
      <OverviewMainImage product={product} bleed={bleed + OVERVIEW_PADDING} />

      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', pb: 4 }}>
        <Typography variant="body1">{product.description}</Typography>
      </Box>

      {product.descriptionForProposals && (
        <Box sx={{ pt: 4 }}>
          <ReactMarkdown>{product.descriptionForProposals}</ReactMarkdown>
        </Box>
      )}

      <OverviewImageGallery product={product} />

      <OverviewTabsWithChipsContent product={product} />

      <OverviewTabsWithMiscellaneousChips product={product} isLoggedIn={isLoggedIn} />

      <OverviewTabsWithAccordion product={product} isLoggedIn={isLoggedIn} />

      {isLoggedIn && product.idEam != null && (
        <Box sx={{ mx: 0, mb: '1rem', ml: '1rem' }}>
          <Typography sx={{ mb: 2 }}>
            <Box
              component="a"
              href={`https://alm.andritz.com/jira/secure/insight/assets/EAM-${product.idEam}`}
              target="_blank"
              rel="noreferrer"
              sx={{ cursor: 'pointer' }}
            >
              <strong>LINK CMDB</strong>
            </Box>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default Overview;
